import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';

import 'jquery_autoresize';
import 'bootstrap-3-typeahead';

import ActivityView from 'views/activity';
import ActivityCollection from 'collections/activity';
import ActivityLogCollection from 'collections/activity_log';
import RecentActivityLogCollection from 'collections/recent_activity_log';


/* This view is meant to display a list of activities that can be logged */
export default Backbone.View.extend({
  events: {
    'click input.add-custom-activity': 'add_custom_activity',
    'input .search-activities textarea': 'show_hide_add_custom',
  },

  initialize: function (options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    // Templates
    this.labelTmpl = _.template($('#form-label-template').html(), {
      variable: 'data'
    });
    this.activity_tmpl = _.template($('#activity').html());

    // Page Elements
    this.activity_list = $('.activity-list', this.el);
    this.search_activities = $('.search-activities', this.el);
    this.search_field = $('textarea', this.search_activities);
    this.add_custom_btn = $('.add-custom-activity', this.search_activities);

    this.options = options;
    this.parent_view = this.options.parent_view;
    this.type = this.options.type;
    this.filter = this[this.type + '_filter'] || this.noop_filter;
    this.builder = this[this.type + '_builder'] || this.noop_builder;
    this.planned_activity_collection = this.parent_view.planned_activity_collection;
    this.activity_log_collection = this.parent_view.activity_log_collection;
    this.activity_group_collection = this.parent_view.activity_group_collection;
    this.mood_booster_collection = this.parent_view.mood_booster_collection;
    this.date_nav = this.options.date_nav;
    this.activity_views = {};

    // Custom activity setup
    var custom_slug = 'Custom';
    this.custom_activity_group = this.activity_group_collection.findWhere({
      slug: custom_slug
    });

    // Any time the collections are updated, re-render this view
    this.collection.on('remove', this.render_async);
    this.planned_activity_collection.on('sync', this.render_async);
    this.options.date_nav.on('change', this.render_async);
    if (this.type == 'today') {
      // Only re-render views that actually have elements being added
      // and removed
      this.activity_log_collection.on('add remove', this.render);
    }

    // Autocomplete
    if (this.search_activities.length) {
      this.search_field.on('keypress', this.search_custom);
      this.typeahead = this.search_field.typeahead({
        source: this.search_source,
        fitToElement: true,
        afterSelect: this.search_select,
      });
    }
  },

  activity_error: function (msg) {
    // Call this when there is an error adding or logging a new activity.
    // Pass the error message to display above the activity omni box
    var new_error = $(this.labelTmpl({
      has_error: true,
      label: msg,
      hidden: msg === '',
    }));
    if (this.error) {
      this.error.replaceWith(new_error);
    } else {
      this.search_field.before(new_error);
    }
    this.error = new_error;
  },

  search_source: function (query, process) {
    var activities = new ActivityCollection();
    activities.on('sync', function (collection) {
      process(collection.toJSON());
    });
    activities.search({ params: { q: query }});
  },

  search_select: function (activity_obj) {
    this.log_activity(this.collection.find({ id: activity_obj.id }));
    this.search_field.val('');
    this.show_hide_add_custom();
  },

  search_custom: function (e) {
    if (e.keyCode === KEYCODES.ENTER) {
      // Pressed enter, add a custom activity
      e.preventDefault();
      this.add_custom_activity();
      return false;
    }
  },

  show_hide_add_custom: function () {
    // Search field content changed, show/hide the add button
    if (this.search_field.val().length > 0) {
      this.search_field.addClass('typing');
      this.add_custom_btn.removeClass('hide');
    } else {
      this.search_field.removeClass('typing');
      this.add_custom_btn.addClass('hide');
    }
  },

  render_async: function () {
    setTimeout(this.render, 0);
  },

  render: function () {
    // Rebuild user favorites collection
    this.user_favorites = new ActivityCollection(this.collection.models, {
      comparator: ActivityCollection.user_favorites,
    });
    // Run the collection filter/builder
    var sub_collection = this.builder(this.collection.filter(this.filter));

    // Add activities to the list
    this.activity_list.find('li:not(".search-activities")').remove();
    this.activity_list.prepend(sub_collection.reduce(this.setup_activity, $()));
    $('.mood-booster.starred', this.activity_list).tooltip();
  },

  setup_activity: function (previous_activities, activity) {
    var mood_booster = this.mood_booster_collection.findWhere({
      activity: activity.get('resource_uri'), isTop: true });
    var content = $(this.activity_tmpl({
      activity: activity,
      group: activity.get_group(this.activity_group_collection),
      custom_activity_group: this.custom_activity_group,
      mood_booster: mood_booster
    }));
    if (_.has(this.activity_views, activity.id)) {
      // Already have the view, don't bother recreating it
      this.activity_views[activity.id].setElement(content);
      this.activity_views[activity.id].render();
    } else {
      // We don't have an activity view yet, create one
      this.activity_views[activity.id] = new ActivityView(_.extend(
        this.options, {
          el: content,
          model: activity,
          activities_view: this
        })).render();
    }
    return previous_activities.add(content);
  },

  // Activity list builders/filters
  noop_builder: function (collection) {
    return collection;
  },

  noop_filter: function (activity, i) {
    return true;
  },

  popular_filter: function (activity, i) {
    return i < 5;
  },

  today_builder: function (collection) {
    // Rebuild the collection in our custom order
    var result = new ActivityCollection([], { comparator: null }),
      // Split today's collection by planned vs logged
      grouped = _.groupBy(collection, function (activity) {
        return this.planned_activity_collection.findWhere({
          activity: activity.get('resource_uri')
        }) ? 'planned' : 'logged';
      }, this);
    // Start with planned and logged activities for the day, make sure
    // sublists are sorted by most popular
    result.add(_.union(
      new ActivityCollection(grouped.planned).models,
      new ActivityCollection(grouped.logged).models
    ));
    // Add the user's favorite activities until the collection has 5
    this.user_favorites.find(function (a) {
      if (result.size() < 5 && a.get('num_user_activitylogs') > 0 && !result.contains(a)) {
        result.add(a);
      }
      return result.size() > 4;
    });
    // If we still don't have 5 activities, fill out with community favs
    this.collection.find(function (activity) {
      if (result.size() < 5 && !result.contains(activity)) {
        result.add(activity);
      }
      return result.size() > 4;
    });
    return result;
  },

  today_filter: function (activity, i) {
    // Filters the activity collection down to just activities that
    // were either planned or logged today
    var opts = {
      activity: activity.get('resource_uri'),
      date: this.date_nav.formatted_date(),
    };
    return this.planned_activity_collection.findWhere(opts) ||
              this.activity_log_collection.findWhere(opts);
  },

  log_activity: function (activity) {
    var log_attrs = {
      activity: activity.get('resource_uri'),
      date: this.date_nav.formatted_date(),
    };
    if (this.activity_log_collection.findWhere(log_attrs)) {
      // Already have a log, bail
      return;
    }
    this.activity_log_collection.create(log_attrs, {
      wait: true,
      success: this.render,
      error: function () {
        this.activity_error('Error logging activity.');
      }.bind(this)
    });
  },

  log_custom_activity: function (activity) {
    this.activity_error('');
    this.log_activity(activity);
    this.search_field.val('');
    this.show_hide_add_custom();
  },

  add_custom_activity: function () {
    var self = this,
      activity_name = this.search_field.val(),
      activity_slug = activity_name.toLowerCase(),
      activity_group = self.custom_activity_group.get('resource_uri');

    if (activity_name === '') {
      return;
    }
    if (activity_name.length > 64) {
      self.activity_error('Please use a shorter activity name.');
      return;
    }

    var name_compare = $.trim(activity_name).toLowerCase(),
      activity = self.collection.find(function (model) {
        return name_compare === $.trim(model.get('name')).toLowerCase();
      });
    if (activity) {
      this.log_custom_activity(activity);
    } else {
      self.collection.create({
        name: activity_name,
        slug: activity_slug,
        group: activity_group,
        present_tense: activity_name
      }, {
        wait: true,
        success: this.log_custom_activity,
        error: function () {
          self.activity_error('Error creating activity.');
        }
      });
    }
  }
});



// WEBPACK FOOTER //
// ./static/js/views/activities.js